
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IMyOptions, ModalDirective } from 'ng-uikit-pro-standard';
import { DowwnloadService } from 'src/app/services/dowwnload.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-download-data',
  templateUrl: './download-data.component.html',
  styleUrls: ['./download-data.component.scss']
})
export class DownloadDataComponent implements OnInit {

  @ViewChild('addModal', { static: true }) addModal!: ModalDirective;

  @Input() stateModalDownload: boolean;
  @Input() urlArcgis2: any;

  @Output() reponseStateModalDownload = new EventEmitter();

  data: any = [];
  objectForm: FormGroup;

  titleModal: string = 'Descarga de Datos';
  isButtonDisabled: boolean = false;

  currentType: string;
  currentChannel: string;

  channelsOriginal: any = [];
  channels: any = [];
  types: any = [];

  dataFilter: any;
  nameDownload: string;

  typeService = '';

  public myDatePickerOptions: IMyOptions = {};

  constructor(
    private dowwnloadService: DowwnloadService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getTypes(this.typeService);
    this.getChannels();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.stateModalDownload) {
      this.addModal.show();
      this.reponseStateModalDownload.emit(false);
    }
  }

  initForm(): void {
    this.objectForm = this.fb.group({
      channel: ['', Validators.required],
      type: ['', Validators.required],
      fecha_inicio: ['', Validators.required],
      fecha_fin: ['', Validators.required]
    });
  }

  /**
   * Descarga los datos obtenidos desde el backend
   * en formato Excel.
   */
  downloadData(): void {

    const modifiedData = this.data.map(obj => {
      const { channel_id, ...restoDeDatos } = obj;
      return restoDeDatos;
    });

    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(modifiedData);

    const workbook: XLSX.WorkBook = {
      Sheets: {
        'Datos': worksheet
      },
      SheetNames: ['Datos']
    };

    const nameFile = `${this.nameDownload}_${this.currentChannel}.xlsx`;

    XLSX.writeFile(workbook, nameFile);

    this.isButtonDisabled = false;
  }

  /**
   * Inicia la descarga de los datos.
   */
  download(): void {
    if (!this.currentChannel || !this.currentType) {
      return;
    }

    this.isButtonDisabled = true;
    this.getData(this.currentChannel, this.currentType);
  }

  openModal(): void {
    this.addModal.show();
  }

  /**
   * Selección del tipo de instrumento.
   * Filtra los canales asociados al sensor_type_id.
   */
  changedType(event: any): void {

    console.log('EVENT:', event.gid);

    this.channels = this.channelsOriginal.filter(
      object =>
        object.sensor_type_id == event.gid &&
        object.id != 0 &&
        object.id != '0'
    );

    this.currentType = event.name;
    this.nameDownload = event.type2;

    this.currentChannel = null;
  }

  /**
   * Selección del canal.
   */
  changedChannel(event: any): void {

    console.log('EVENT:', event.id);

    this.currentChannel = event.id;
  }

  /**
   * Obtiene los tipos de instrumentos disponibles.
   */
  getTypes(type: string): void {

    this.dowwnloadService.getTypes().subscribe({

      next: (resp: any) => {

        this.types = resp;

        console.log(
          'UID:',
          this.urlArcgis2?.uid
        );

        if (this.urlArcgis2?.uid == '65fd9f75aa0e312a459590ca') {

          // Instrumentos de monitoreo geotécnico
          this.types = this.types.filter(object =>
            [
              'tdr',
              'tdr2',
              'ipi',
              'ipi2',
              'saav'
            ].includes(object.name)
          );

        } else {

          // Instrumentos convencionales
          this.types = this.types.filter(object =>
            [
              'tiltmeter',
              'crackmeter',
              'laser',
              'tiltmeter2'
            ].includes(object.name)
          );

        }

        /**
         * Traducción de nombres técnicos
         * a nombres visibles en la interfaz.
         */
        const tipoTransformado: { [key: string]: string } = {

          'tiltmeter': 'Tiltmeter biaxial',

          'crackmeter': 'Crackmeter',

          'laser': 'Distanciómetro láser',

          'tiltmeter2': 'Tiltmeter triaxial',
          'tdr': 'TDR',
          'tdr2': 'TDR 2',
          'ipi': 'Inclinómetros',
          'ipi2': 'Inclinómetros SAAV',

        };

        const dispositivosTransformados = this.types.map(dispositivo => {

          return {
            gid: dispositivo.gid,
            name: dispositivo.name,
            type2: tipoTransformado[dispositivo.name] || dispositivo.name,
            tableName: dispositivo.tabla_registros
          };

        });

        this.types = dispositivosTransformados;

        console.log(
          'Response Types:',
          this.types
        );

      },

      error: (err) => {
        console.error('Error obteniendo tipos:', err.message);
      },

      complete: () => {
        console.log('Completed getTypes');
      }

    });

  }

  /**
   * Obtiene todos los canales disponibles.
   */
  getChannels(): void {

    this.dowwnloadService.getChannels().subscribe({

      next: (resp: any) => {

        this.channelsOriginal = resp;

        console.log(
          'Response Channels:',
          resp
        );

      },

      error: (err) => {
        console.error('Error obteniendo canales:', err.message);
      },

      complete: () => {
        console.log('Completed getChannels');
      }

    });

  }

  /**
   * Obtiene los registros del canal seleccionado.
   */
  getData(id: string, type: string): void {

    this.dowwnloadService.getData(id, type).subscribe({

      next: (resp: any) => {

        this.data = resp;

        this.downloadData();

        console.log(
          'Response Data:',
          resp
        );

      },

      error: (err) => {

        console.error('Error obteniendo datos:', err.message);

        this.isButtonDisabled = false;

      },

      complete: () => {
        console.log('Completed getData');
      }

    });

  }

}
